import React, { MutableRefObject, useCallback } from 'react';
import { UseActiveItemData, UseActiveItemGetLinkPropsData, UseActiveItemProps } from '../types';

export function useActiveItem({ eventKey, href, activeKey, setActiveContent }: UseActiveItemProps): UseActiveItemData {
	const mounted = React.useRef<boolean>(false);
	const itemRef = React.useRef<HTMLAnchorElement>() as MutableRefObject<HTMLAnchorElement>;

	React.useEffect(() => {
		const nextEventKey = eventKey ? eventKey : href;
		if (!mounted.current && activeKey === nextEventKey) {
			mounted.current = true;
			setActiveContent({
				key: nextEventKey,
				content: itemRef.current.textContent
			});
		}

		return () => {
			mounted.current = false;
		};
	}, [activeKey, eventKey, href, setActiveContent]);

	const isActive = useCallback(() => {
		return !!(activeKey && (eventKey === activeKey || href === activeKey));
	}, [activeKey, eventKey, href]);

	const getLinkProps = useCallback(
		(overrideProps: React.AnchorHTMLAttributes<HTMLAnchorElement>): UseActiveItemGetLinkPropsData => {
			return {
				ref: itemRef,
				'aria-current': isActive() ? 'page' : undefined,
				href,
				...overrideProps
			};
		},
		[href, isActive]
	);

	return {
		isActive,
		getLinkProps
	};
}
